import React, { useRef, useEffect, useState } from "react";
import { Card, CardActionArea, Button } from "@material-ui/core";
import Webcam from "react-webcam";
import { runBlazeFace, stopBlazeFace, drawRef, clearRef, loadBlazeFaceModel } from "../../api/BlazeFace";
import { useVideo } from "../../api/VideoProvider";
import { pRecordVideo, pWebcam, pVideots, pVideoConstraintsPortrait, pRecordVideoPortrait, pVideoConstraints, pVideoConstraintsSquare, pRecordVideoSquare, pStatus, pMediapipeHandDetected, pRepetitionRecord } from "../../utils/parameters";
import { useReactMediaRecorder } from "react-media-recorder";
import { CountdownTimer } from "../../components/home/CountdownTimer";
import { RecordingChip } from "../home/RecordingChip";
// import { useMediapipe } from "../../api/MediapipeHandsPose";
import { useMediapipe } from '../../api/MediapipeHolistic';
import { makeStyles } from '@material-ui/core/styles';
import PanToolIcon from '@mui/icons-material/PanTool';
import { red, green, indigo } from '@mui/material/colors';
import { useHandsPoseDonate } from "../../api/MediapipeHandsPoseDonate";


const useStyles = makeStyles((theme) => ({
    webcamOverlayLeft: {
        opacity: 0.15,
        position: 'absolute',
        backgroundColor: 'red',
        width: '50%',
        height: '100%',
        marginLeft: '0%',
        // display: 'none',
    },
    webcamOverlayRight: {
        opacity: 0.1,
        position: 'absolute',
        backgroundColor: 'blue',
        width: '50%',
        height: '100%',
        marginLeft: '50%',
        // display: 'none',
    },
    webcamFixPositionVerticalView: {
        //marginTop: '-250px'
        marginTop: '-330px'
    },
    webcamOverlayVisible: {
      display: "block !important",
      zIndex: 100,
    },
    webcamOverlayActive: {
      opacity: 0.4,
    },
    handOverlayRight: {
      opacity: 1,
      position: 'absolute',
      color: 'blue',
      transform: "translate(300px, 300px) scale(2);",
      display: 'none',
    },
    handOverlayRightDesktop: {
      transform: "translate(600px, 180px) scale(3)",
    },
    handOverlayLeft: {
      opacity: 1,
      position: 'absolute',
      color: 'red',
      transform: "translate(20px, 300px) scale(2);",
      display: 'none',
    },
    handOverlayLeftDesktop: {
      transform: "translate(30px, 180px) scale(3);"
    }

  }));

export function WebcamCardMediapipeDonateSign(props) {
  const { children, devicePortrait, setVideo, settings, permissions, activateMediapipe, setHandDetectedArray, handDetected, pauseMediapipe, deviceId } = props;
  /* Video */
  const { startRecording, stopRecording, status, mediaBlobUrl } = useReactMediaRecorder(devicePortrait ? { ...pRecordVideoPortrait, video:{ ...pRecordVideoPortrait.video, deviceId: {exact: deviceId} } } : { ...pRecordVideo, video:{ ...pRecordVideo.video, deviceId: {exact: deviceId} } });
  const { setFaceStatus, faceStatus } = useVideo();
  const [ forceAspect, setForceAspect ] = useState(false);
  /* Refs */
  const canvasRef = useRef(null);
  const auxCanvasRef = useRef(null);
  const webcamRef = useRef(null);
  /* Mediapipe */
  const { start_Mediapipe, stop_Mediapipe, mediapipe_getFPS, out_hand_detected } = useHandsPoseDonate()
  const interval_mediapipe = useRef(null);

  const [ showRepeat, setShowRepeat ] = useState(false);

  const repeatVideoRef = useRef(null);
  const styles = useStyles();

  useEffect(() => {
    return () => {
      clearInterval(interval_mediapipe.current)
      interval_mediapipe.current = null
      stop_Mediapipe()
    };
  }, []);

  useEffect(() => {
    // console.log("🚀 ~ file: WebcamCardMediapipe.js:27 ~ WebcamCardMediapipe ~ activateMediapipe:", activateMediapipe)

    if (webcamRef.current !== null) {
        if (activateMediapipe === true){

            console.log('WEBCAMREF.current', webcamRef.current.video)
            start_Mediapipe(webcamRef.current.video);

            if (interval_mediapipe.current === null) {
                interval_mediapipe.current = setInterval(() => {
                    setHandDetectedArray((prevArray) => {
                      if (pauseMediapipe) {
                        return prevArray.map(() => pMediapipeHandDetected.NONE); // Si pause es true, establece todos los elementos a pMediapipeHandDetected.NONE
                      } else {
                        const newArray = prevArray.slice(1); // Elimina el primer elemento
                        newArray.push(out_hand_detected()); // Añade el nuevo valor de handDetected al final del array
                        return newArray;
                      }
                    });
                }, (200)); // update each 1 second
              } 

        }else{
            stop_Mediapipe()
            clearInterval(interval_mediapipe.current)
            interval_mediapipe.current = null
            setHandDetectedArray((prevArray) => {
                return prevArray.map(() => pMediapipeHandDetected.NONE); // Si pause es true, establece todos los elementos a pMediapipeHandDetected.NONE
              }
            );
        }
    }
  }, [activateMediapipe]);
  

  /* Blazeface runs only in the webcam mode (not during the repetition) */
  /* Also, it starts running after hitting the 'record' button */
  useEffect(() => {
    let timerId;

    switch (faceStatus) {
      case pStatus.runTf:
        if (webcamRef.current !== null) {
          /* run face engine and show galibo */
          runBlazeFace(webcamRef.current.video, canvasRef.current, setFaceStatus);
          drawRef(webcamRef.current.video, auxCanvasRef.current);
          setFaceStatus(pStatus.faceDetected);
        }
        break;
      case pStatus.init:
      case pStatus.countdown:
        stopBlazeFace();
        if (auxCanvasRef.current !== null) {
          clearRef(auxCanvasRef.current);
        }
        break;
      case pStatus.record:
        startRecording();
        if (settings.repeat_after_record !== pRepetitionRecord.NO_REPEAT){
          setShowRepeat(true)
        }
        
        break;
      case pStatus.rep:
        stopRecording();
        if (settings.repeat_after_record === pRepetitionRecord.ONE_REPETITION){
          timerId = setTimeout(() => {
            setShowRepeat(false);
          }, (settings.timer * 1000));
        }
        break;
      default:
        break;
    }
    // eslint-disable-next-line

    return () => {
      clearTimeout(timerId); // clear the timer if the effect re-runs before it expires
    };
  }, [faceStatus]);

  /* Detect when the video is ready */
  useEffect(() => {
    if (mediaBlobUrl !== null) {
      setVideo(mediaBlobUrl);
    }
  }, [mediaBlobUrl, setVideo]);

  /* Unmounted component */
  useEffect(() => {
    loadBlazeFaceModel();
    return () => {
      stopBlazeFace();
    };
  }, []);


  // useEffect(() => {
  //   console.log("🚀 ~ file: WebcamCardMediapipe.js:141 ~ WebcamCardMediapipe ~ handDetected:", handDetected)
  // }, [handDetected]);

  useEffect(() => {
    if (settings.repeat_after_record === pRepetitionRecord.LOOP){
      setShowRepeat(true)
    }else{
      setShowRepeat(false)
    }
  }, [settings.repeat_after_record]);

  useEffect(() => {
    if (showRepeat === false){
      setFaceStatus(pStatus.rep_end)
    }
  }, [showRepeat]);

  function showState(){
    console.log('showRepeat: ', showRepeat)
  }
  
  /* Adapt to Camera Aspect Ratio */
  useEffect(() => {
    handleGetAspect();

    console.log("🚀 ~ file: WebcamCardMediapipe.js:218 ~ WebcamCardMediapipe ~ deviceId:", deviceId)
  }, [deviceId]);
  

  function handleGetAspect() {
    if (webcamRef.current !== null) {
      const newAspect = (webcamRef.current.video.offsetWidth / webcamRef.current.video.offsetHeight).toFixed(4);
      // Handle mismatching situations, ie. "a portrait device that has a landscape camera" or "landscape device that has a portrait camera"
      if (devicePortrait) {
        setForceAspect(newAspect > 1); //Portrait To Landscape
      } else {
        setForceAspect(newAspect < 1); //Landscape To Portrait
      }
    }
  }  
    
  function handleOnUserMedia() {
    setTimeout(() => {      
      handleGetAspect();
    }, 200); //This is a dirty patch, check a more stable solution. Around 40ms stops being fast enough while testing, but it would depend on the device/connection speed
  }

  /* STATES :
   * before recording: webcam and canvas
   * recording: only webcam
   * repetition: video in loop
   */
  return (
    <>
        {/* <Button onClick={showState}>STATE SHOWREPEAT</Button> */}

        <Card data-tour='tourCam_7' className={`sig_Home_Camera_Root ${props.deviceLarge ? "" : "sig_Home_Camera_Root_LargeDevice"}`}>
            <CardActionArea style={{ position: 'relative' }}>
            <div className="sig_Home_Camera_Canvas_BorderTop"></div>
            <div className="sig_Home_Camera_Canvas_BorderBottom"></div>
            {permissions && 
            <Webcam className={`sig_Home_Camera_Canvas sig_Home_Camera_Feed ${devicePortrait ? 'sig_Home_Camera_Portrait' : 'sig_Home_Camera_Landscape'}${forceAspect ? 'Forced' : ''}`} 
              ref={webcamRef} 
              audio={pWebcam.audio} 
              mirrored={pWebcam.mirrored} 
              screenshotFormat="image/jpeg"             
              videoConstraints={devicePortrait ? { ...pVideoConstraintsPortrait, deviceId: {exact: deviceId} } 
                                : { ...pVideoConstraints, deviceId: {exact: deviceId} }} 
              style={{ zIndex: 7, audio: false }} 
              onUserMedia={handleOnUserMedia}/>}
            {faceStatus !== pStatus.rep ? (
                <>
                {faceStatus === pStatus.record ? (
                    <></>
                ) : (
                  <>
                    <canvas className="sig_Home_Camera_Canvas sig_Home_Camera_FaceStatus" ref={canvasRef} style={{ zIndex: 9, transform: "scaleX(-1)" }} />
                    <canvas className="sig_Home_Camera_Canvas sig_Home_Camera_FaceStatusAux" ref={auxCanvasRef} style={{ zIndex: 8 }} />

                    <div className={styles.webcamOverlayRight + (activateMediapipe ? ' ' + styles.webcamOverlayVisible : '') + (handDetected==pMediapipeHandDetected.RIGHT || handDetected==pMediapipeHandDetected.BOTH ? ' ' + styles.webcamOverlayActive : '') + (props.desktop  ? ' ' + styles.webcamFixPositionVerticalView : '')}/>
                    <div className={styles.webcamOverlayLeft +  (activateMediapipe ? ' ' + styles.webcamOverlayVisible : '') + (handDetected==pMediapipeHandDetected.LEFT || handDetected==pMediapipeHandDetected.BOTH ? ' ' + styles.webcamOverlayActive : '') + (props.desktop  ? ' ' + styles.webcamFixPositionVerticalView : '')}/>

                    <div className={styles.handOverlayRight + (handDetected==pMediapipeHandDetected.RIGHT || handDetected==pMediapipeHandDetected.BOTH ? ' ' + styles.webcamOverlayVisible : '')  + (props.desktop  ? ' ' + styles.handOverlayRightDesktop : '')}>
                      <PanToolIcon fontSize="large"/>
                    </div>
                    <div className={styles.handOverlayLeft + (handDetected==pMediapipeHandDetected.LEFT || handDetected==pMediapipeHandDetected.BOTH ? ' ' + styles.webcamOverlayVisible : '') + (props.desktop  ? ' ' + styles.handOverlayLeftDesktop : '')}>
                      <PanToolIcon fontSize="large"/>
                    </div>  
                    </>
                )}
                </>
            ) : (

              <>
                { showRepeat ? (
                  <>
                    <video ref={repeatVideoRef} className={`sig_Home_Camera_Canvas sig_Home_Camera_Feed ${devicePortrait ? 'sig_Home_Camera_Portrait' : 'sig_Home_Camera_Landscape'}${forceAspect ? 'Forced' : ''}`} src={mediaBlobUrl} autoPlay loop style={{ zIndex: 8 }}/>

                    <div className={styles.webcamOverlayRight + (activateMediapipe ? ' ' + styles.webcamOverlayVisible : '') + (handDetected==pMediapipeHandDetected.RIGHT || handDetected==pMediapipeHandDetected.BOTH ? ' ' + styles.webcamOverlayActive : '') + (props.desktop  ? ' ' + styles.webcamFixPositionVerticalView : '')}/>
                    <div className={styles.webcamOverlayLeft +  (activateMediapipe ? ' ' + styles.webcamOverlayVisible : '') + (handDetected==pMediapipeHandDetected.LEFT || handDetected==pMediapipeHandDetected.BOTH ? ' ' + styles.webcamOverlayActive : '') + (props.desktop  ? ' ' + styles.webcamFixPositionVerticalView : '')}/>

                    <div className={styles.handOverlayRight + (handDetected==pMediapipeHandDetected.RIGHT || handDetected==pMediapipeHandDetected.BOTH ? ' ' + styles.webcamOverlayVisible : '')  + (props.desktop  ? ' ' + styles.handOverlayRightDesktop : '')}>
                      <PanToolIcon fontSize="large"/>
                    </div>
                    <div className={styles.handOverlayLeft  + (handDetected==pMediapipeHandDetected.LEFT || handDetected==pMediapipeHandDetected.BOTH ? ' ' + styles.webcamOverlayVisible : '') + (props.desktop  ? ' ' + styles.handOverlayLeftDesktop : '')}>
                      <PanToolIcon fontSize="large"/>
                    </div>  
                  </>
                ):
                <>
                    <div className={styles.webcamOverlayRight + (activateMediapipe ? ' ' + styles.webcamOverlayVisible : '') + (handDetected==pMediapipeHandDetected.RIGHT || handDetected==pMediapipeHandDetected.BOTH ? ' ' + styles.webcamOverlayActive : '') + (props.desktop  ? ' ' + styles.webcamFixPositionVerticalView : '')}/>
                    <div className={styles.webcamOverlayLeft +  (activateMediapipe ? ' ' + styles.webcamOverlayVisible : '') + (handDetected==pMediapipeHandDetected.LEFT || handDetected==pMediapipeHandDetected.BOTH ? ' ' + styles.webcamOverlayActive : '') + (props.desktop  ? ' ' + styles.webcamFixPositionVerticalView : '')}/>

                    <div className={styles.handOverlayRight + (handDetected==pMediapipeHandDetected.RIGHT || handDetected==pMediapipeHandDetected.BOTH ? ' ' + styles.webcamOverlayVisible : '')  + (props.desktop  ? ' ' + styles.handOverlayRightDesktop : '')}>
                      <PanToolIcon fontSize="large"/>
                    </div>
                    <div className={styles.handOverlayLeft + (handDetected==pMediapipeHandDetected.LEFT || handDetected==pMediapipeHandDetected.BOTH ? ' ' + styles.webcamOverlayVisible : '') + (props.desktop  ? ' ' + styles.handOverlayLeftDesktop : '')}>
                      <PanToolIcon fontSize="large"/>
                    </div>  
                
                </>
                }
              </>
            )}
            
            {children}

            </CardActionArea>
            <CountdownTimer/>
            <RecordingChip status={status} />
        </Card>
    </>
  );
}